// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var ReactDOMRe = require("reason-react/src/legacy/ReactDOMRe.bs.js");
var App$BlossomPlayground = require("./App.bs.js");

ReactDOMRe.renderToElementWithId(React.createElement(App$BlossomPlayground.make, {}), "root");

/*  Not a pure module */
